// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { FormatStatus } from 'components/DataTable'
import { FormatThroughput } from './Formatters'

const columns = [{
  columnHeader: 'Radio Code',
  columnKey: 'radioCode',
  sortable: true,
}, {
  columnHeader: 'Radio Manufacturer',
  columnKey: 'companyName',
  sortable: true,
}, {
  columnHeader: 'Model/Family',
  columnKey: 'radioModelFamily',
  sortable: true,
}, {
  columnHeader: 'BW (MHz)',
  columnKey: 'bandwidth',
  columnWidth: '58px',
  sortable: true,
}, {
  columnHeader: 'Max Power (dBm)',
  columnKey: 'txPowerMax',
  sortable: true,
}, {
  cellFormatter: FormatThroughput,
  columnHeader: 'Mbps',
  columnKey: 'modulations',
  sortable: true,
}, {
  columnHeader: 'Modulation',
  columnKey: 'modulationName', // not sure about this one.
  sortable: true,
}, {
  columnHeader: 'Threshold (dBm)',
  columnKey: 'rxThreshold', // not sure about this one.
  sortable: true,
}, {
  columnHeader: 'Frequency (MHz)',
  columnKey: 'frequencyRange',
  sortable: true,
}, {
  columnHeader: 'Spec Date',
  columnKey: 'specDate',
  sortable: true,
}, {
  cellFormatter: FormatStatus,
  columnHeader: 'Status',
  columnKey: 'status',
  columnWidth: '48px',
  sortable: true,
}]

export default columns
